import { Component } from 'react'
import { connect } from 'react-redux'
import { dateFromBackToFront } from 'helpers/dates'
import { refreshToken } from 'reducers/profile/reducer'

class UserManager extends Component {
  debouncedRefreshTokenRequest

  componentDidMount() {
    this.updateDebouncedRefreshToken()
  }

  componentDidUpdate() {
    this.updateDebouncedRefreshToken()
  }

  updateDebouncedRefreshToken = () => {
    const { expiration, refreshToken } = this.props
    clearTimeout(this.debouncedRefreshTokenRequest)

    if (!expiration) return

    // We're going to refresh token when 10m earlier then current token expire
    const msBeforeExpire = 600000
    const msToExpire = dateFromBackToFront(expiration) - Date.now()
    if (msToExpire - msBeforeExpire < 0) return
    this.debouncedRefreshTokenRequest = setTimeout(() => {
      refreshToken()
    }, msToExpire - msBeforeExpire)
  }

  render() {
    return null
  }
}

export default connect(
  state => ({
    expiration: state.getIn(['profile', 'jwtData', 'exp']),
  }),
  { refreshToken },
)(UserManager)
